import { render } from "./FeaturesComponent.vue?vue&type=template&id=3b7303f6&scoped=true"
import script from "./FeaturesComponent.vue?vue&type=script&lang=js"
export * from "./FeaturesComponent.vue?vue&type=script&lang=js"

import "./FeaturesComponent.vue?vue&type=style&index=0&id=3b7303f6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7303f6"]])

export default __exports__